$(function(){
  $(".fliparoo").on("mouseover mousein", function() {
    $hover = $(this).attr("data-hover");
    
    if (~$hover.indexOf("no-image")) {
      $(this).addClass("no-image");
    } else {
     $(this).attr("src", $hover); 
    }
  });
  
   $(".fliparoo").on("mouseout mouseout", function() {
    $idle = $(this).attr("data-idle");
    $hover = $(this).attr("data-hover");

    if (~$hover.indexOf("no-image")) {
      $(this).removeClass("no-image");
    } else {
     $(this).attr("src", $idle); 
    }     
  });
});